var eventCardFilter = (function () {
  var dataAjax = {
      perpage: "12",
      offset: 0,
    },
    query = {},
    queryStringUTM = "",
    mainWrap,
    chosenCustomObj = [],
    filterDropdowns;

  function init() {
    mainWrap = document.querySelector(".display-post-inter.enable-filter");

    if (mainWrap) {
      var clearevFilter = mainWrap.querySelectorAll(".clearevFilter"),
        showMoreBtn = mainWrap.querySelector(
          ".display-post-inter__btn-show-more"
        );

      dataAjax.perpage = mainWrap.dataset.perpage
        ? mainWrap.dataset.perpage
        : 12;

      filterDropdowns = mainWrap.querySelectorAll("select.filter-field");
      var filterTabs = mainWrap.querySelectorAll(
        ".display-post-inter__filter-tab--pill"
      );

      if (filterDropdowns.length > 0) {
        for (var i = 0; i < filterDropdowns.length; i++) {
          if (filterDropdowns[i].value) {
            clearevFilter.forEach(function (e) {
              e.classList.remove("hide");
            });
          }
          var selectElement = new ChosenCustom({
            selector: filterDropdowns[i],
            ID: filterDropdowns[i].getAttribute("id")
              ? filterDropdowns[i].getAttribute("id")
              : "",
            placeholder: filterDropdowns[i].dataset.placeholder
              ? filterDropdowns[i].dataset.placeholder
              : "Select",
            search: true,
            searchPlaceholder: "Search...",
          });

          chosenCustomObj[selectElement.options.ID] = selectElement;
          if (filterDropdowns[i].value) {
            query[filterDropdowns[i].dataset.key] = filterDropdowns[i].value;
          }
          filterDropdowns[i].addEventListener("change", function (evt) {
            evt.preventDefault();

            clearevFilter.forEach(function (e) {
              e.classList.remove("hide");
            });

            dataAjax.offset = 0;
            var that = this;
            if (that.dataset.key) {
              query[that.dataset.key] = that.value;
            }
            dataAjax.query = JSON.stringify(query);

            if (filterTabs.length > 0 && that.dataset.key == "event_type") {
              delete query.event_upcoming;
              for (var l = 0; l < filterTabs.length; l++) {
                if (that.value == filterTabs[l].dataset.filter) {
                  filterTabs[l].classList.add("active");
                } else {
                  filterTabs[l].classList.remove("active");
                }
              }
            }
            eventDataAjax(dataAjax);

            //active
            that
              .closest(".display-post-inter__filter-dd")
              .classList.add("active");

             WebEventTracker.logEvent(EDS.webEvents, "InteractedWithEventsPage", {
              filter_values: dataAjax.query,
              section: 'filtered-events'
            });

            updateQueryStringParameter();
          });
        }
      }

      if (filterTabs.length > 0) {
        for (var i = 0; i < filterTabs.length; i++) {
          filterTabs[i].addEventListener("click", function (evt) {
            evt.preventDefault();
            clearevFilter.forEach(function (e) {
              e.classList.remove("hide");
            });
            dataAjax.offset = 0;
            var that = this;
            // event
            var actionText = evt.target.textContent.trim();
             WebEventTracker.logEvent(EDS.webEvents, "InteractedWithEventsPage", {
              filter_values: actionText,
              section: 'filtered-events'
            });

            var eventFilterKey = "event_type_" + that.dataset.form_id;
            query.event_type = that.dataset.filter;
            var evTypeFilterDD = document.getElementById(eventFilterKey);
            if ("Upcoming" == that.dataset.filter) {
              chosenCustomObj[eventFilterKey].options.resetValue = "";

              if (evTypeFilterDD) {
                evTypeFilterDD
                  .closest(".display-post-inter__filter-dd")
                  .classList.remove("active");
              }
            } else {
              chosenCustomObj[eventFilterKey].options.resetValue =
                that.dataset.filter;

              if (evTypeFilterDD) {
                evTypeFilterDD
                  .closest(".display-post-inter__filter-dd")
                  .classList.add("active");
              }
            }
            chosenCustomObj[eventFilterKey].reset();

            for (var j = 0; j < filterTabs.length; j++) {
              filterTabs[j].classList.remove("active");
            }
            that.classList.add("active");

            dataAjax.query = JSON.stringify(query);
            eventDataAjax(dataAjax);
            updateQueryStringParameter();
          });
        }
      }

      //
      var whiteListParams = [
          "utm_source",
          "utm_medium",
          "utm_platform",
          "utm_content",
          "utm_campaign",
          "utm_campaigncode",
          "utm_term",
        ],
        paramsObj = window.location.search
          .slice(1)
          .split("&")
          .map(function (p) {
            return p.split("=");
          })
          .reduce(function (obj, pair) {
            if (pair.length >= 2) {
              obj[pair[0]] = pair[1];
            }
            return obj;
          }, {});

      //Read from cookie
      if (Object.keys(paramsObj).length == 0) {
        var cookieUtmParams = Cookie.read(
          stage_env_cookie_prefix + "user_utm_data"
        );
        if (cookieUtmParams) {
          paramsObj = bsLib.JSONParse(cookieUtmParams);
        }
      }

      // check white list params
      Object.keys(paramsObj).forEach(function (key) {
        if (whiteListParams.indexOf(key) > -1) {
          query[key] = paramsObj[key];
        }
      });

      //EV Clear Button
      if (clearevFilter.length) {
        clearevFilter.forEach(function (e) {
          e.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();

              var that = this,
                dataAjax = {
                  perpage: mainWrap.dataset.perpage,
                  offset: 0,
                };

               WebEventTracker.logEvent(EDS.webEvents, "InteractedWithEventsPage", {
                filter: 'clear',
                section: 'filtered-events'
              });

              eventDataAjax(dataAjax);

              Object.keys(chosenCustomObj).forEach(function (i, e) {
                chosenCustomObj[i].options.resetValue = "";
                chosenCustomObj[i].reset();
              });

              if (filterTabs.length > 0) {
                for (var i = 0; i < filterTabs.length; i++) {
                  filterTabs[i].classList.remove("active");
                }
              }

              clearevFilter.forEach(function (e) {
                e.classList.add("hide");
              });

              var filterDD = document.querySelectorAll(
                ".display-post-inter__filter-dd"
              );
              if (filterDD) {
                filterDD.forEach(function (e) {
                  e.classList.remove("active");
                });
              }
              query = {};

              // check white list params
              Object.keys(paramsObj).forEach(function (key) {
                if (whiteListParams.indexOf(key) > -1) {
                  query[key] = paramsObj[key];
                }
              });

              amplitudeEventOnCard();
              updateQueryStringParameter();
            },
            false
          );
        });
      }

      if (showMoreBtn) {
        showMoreBtn.addEventListener("click", function (evt) {
          evt.preventDefault();

          dataAjax.offset = this.dataset.offset;
          dataAjax.query = JSON.stringify(query);
          eventDataAjax(dataAjax);
          updateQueryStringParameter();
          amplitudeEventOnCard();
        });
      }
      resetUpcomingTab();
      amplitudeEventOnCard();
      window.addEventListener("resize", function () {
        resetUpcomingTab();
      });
    }

    var scrollToBtn = document.querySelector("#card-block-inter__header-cta");
    if (scrollToBtn) {
      scrollToBtn.addEventListener("click", function () {
        targetElement = document.querySelector(scrollToBtn.dataset.target);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }
  }
  function amplitudeEventOnCard() {
    // Select all CTA buttons within event cards
    var cardBtns = document.querySelectorAll(".display-post-inter.enable-filter .event_card--btn");
    if (cardBtns.length > 0) {
      cardBtns.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          var eventCard = event.target.closest(".event_card");

          if (eventCard) {
            var activeFilter = document.querySelector(".display-post-inter__filter-tab--pill.active"),
                activeSelection = document.querySelectorAll(".display-post-inter__filter-dd.active"),
                eventTitle = eventCard.querySelector(".event_card--heading") ? eventCard.querySelector(".event_card--heading").innerText.trim() : "",
                ctaText = event.target.innerText.trim(),
                activeTabs = {};

            if (activeSelection.length > 0) {
              activeSelection.forEach(function (selectElement) {
                var selectButton = selectElement.querySelector(".select-dropdown__button-span"),
                    key = selectElement.querySelector(".filter-field").getAttribute("data-key"),
                    value = selectButton ? selectButton.textContent.trim() : "";

                if (key && value) {
                  activeTabs[key] = value;
                }
              });
            }

             WebEventTracker.logEvent(EDS.webEvents, "InteractedWithEventsPage", {
              section: 'event-card',
              cta: ctaText,
              card_title: eventTitle,
              active_tab: activeFilter ? activeFilter.getAttribute("data-filter") : "NA",
              active_selection: JSON.stringify(activeTabs),
            });
          }
        });
      });
    }
  }
  function eventDataAjax(dataAjax) {
    var pageBtn = mainWrap.querySelector(".display-post-inter__btn-show-more"),
      noResultsEvent = mainWrap.querySelector("#noResultsEvent"),
      loaderContent = mainWrap.querySelector(
        ".display-post-inter__loading-container"
      );
    mainWrap.classList.add("loading");
    pageBtn.classList.add("visible-hide");
    if (loaderContent) {
      loaderContent.classList.remove("hide");
    }

    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",
      bsLib.extend(
        {
          action: "bstack_event_card_data",
          security: ajax_initialize_script.ajax_nonce,
        },
        dataAjax
      ),
      true, //async
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }, //request header
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            eventRow = mainWrap.querySelector(".display-post-inter__cards");
          if (dataRequest.status) {
            if (dataAjax.offset > 0) {
              eventRow.insertAdjacentHTML("beforeend", dataRequest.html);
            } else {
              eventRow.innerHTML = dataRequest.html;
            }

            pageBtn.dataset.offset = dataRequest.offset;

            if (loaderContent) {
              loaderContent.classList.add("hide");
            }

            amplitudeEventOnCard();
            if (dataRequest.filtered == 0) {
              noResultsEvent.classList.remove("hide");
              mainWrap
                .querySelector(".display-post-inter__load-more")
                .classList.add("hide");
            } else {
              noResultsEvent.classList.add("hide");

              if (
                dataRequest.offset * dataAjax.perpage <
                dataRequest.filtered
              ) {
                mainWrap
                  .querySelector(".display-post-inter__load-more")
                  .classList.remove("hide");
                pageBtn.classList.remove("visible-hide");
              } else {
                mainWrap
                  .querySelector(".display-post-inter__load-more")
                  .classList.add("hide");
              }
            }
            lazyLoading.show();
            mainWrap.classList.remove("loading");
          }
        }
      }, //success
      function () {} //error object
    );
  }

  function resetUpcomingTab() {
    var upcomingEle = document.querySelector('[data-filter="Upcoming"]');
    if (window.innerWidth < 640) {
      if (upcomingEle != null && upcomingEle.classList.contains("active")) {
        eventFilterKey = "event_type_" + upcomingEle.dataset.form_id;

        chosenCustomObj[eventFilterKey].options.resetValue =
          upcomingEle.dataset.filter;
        chosenCustomObj[eventFilterKey].reset();
      }
    } else {
      if (upcomingEle != null && upcomingEle.classList.contains("active")) {
        eventFilterKey = "event_type_" + upcomingEle.dataset.form_id;

        chosenCustomObj[eventFilterKey].options.resetValue = "";
        chosenCustomObj[eventFilterKey].reset();
      }
    }
  }

  // Function to update Query String in the URL
  // https://jsfiddle.net/bp3tmuxh/1/
  function updateQueryStringParameter() {
    if (Object.keys(query).length > 0) {
      queryStringUTM =
        "?" +
        Object.keys(query)
          .map(function (key) {
            return key + "=" + query[key];
          })
          .join("&");
    } else {
      queryStringUTM = "";
    }

    var uri = window.location.href.split("?")[0];

    if (history.pushState) {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      //update referrer
      var newReferrer = window.location.href;
      Object.defineProperty(mainWrap, "referrer", {
        configurable: true,
        get: function () {
          return newReferrer;
        },
      });

      window.history.pushState(
        { path: window.location.href },
        "",
        uri + queryStringUTM + hash
      );
    }
  }
  return {
    init: init,
  };
})();

eventCardFilter.init();
